export default "__VITE_ASSET__71bc636d__"